import React from 'react'
import HowItWorks from '../components/HowItWorks'

function HowItWorksPage() {
  return (
    <div>
      <HowItWorks />
    </div>
  )
}

export default HowItWorksPage